module.exports = __webpack_public_path__ + "static/media/icon_confidence.125d6979.png";